import React from 'react'
import InterestsCheckboxSelector from '../checkbox-selector'
import useToasts from '../../../hooks/use-toasts'
import { Button } from 'react-bootstrap'
import { X, Check } from 'react-bootstrap-icons'
import useUserInterests from '../../../hooks/use-user-interests'
import Spinner from '../../common/spinner-container'
import useUserInterestsMutations from '../../../hooks/use-user-interests-mutations'

const EditInterestsForm = ({
    userId,
    onComplete = () => {}
}) => {
    const {
        success: toastSuccess,
        error: toastError
    } = useToasts({
        successMessage: 'Interests updated!',
        errorMessage: 'Error updating interests.',
        onSuccess: onComplete,
    })

    const {
        userInterests: interests,
        isLoading,
    } = useUserInterests({
        userId,
    })

    const {
        isUpdating,
        updateUserInterests,
        userInterests,
        setUserInterests,
    } = useUserInterestsMutations({
        interests,
        onSuccess: toastSuccess,
        onError: toastError,
        userId,
    })

    if (isLoading) {
        return (<Spinner label='Loading interests...' />)
    }

    if (isUpdating) {
        return (<Spinner label='Saving interests...' />)
    }

    return (
        <React.Fragment>
            <div>Select your interests:</div>
            <InterestsCheckboxSelector value={userInterests} onChange={setUserInterests} />
            <div style={{ paddingTop: '10px'}} className='text-right'>
                <Button variant='link' onClick={() => onComplete()} title='Discard changes'><X size={30} /></Button>
                <Button variant='link' onClick={() => updateUserInterests()} title='Save changes'><Check size={35} /></Button>
            </div>
        </React.Fragment>
    )
}

export default EditInterestsForm